import React from 'react'
import SuppliersFormAdd from '../form/SuppliersFormAdd'

const SuppliersOptions = () => {
  return (
    <div>
        <SuppliersFormAdd />
    </div>
  )
}

export default SuppliersOptions